/**
 * Cookie utilities.
 * @module utils/cookies
 */

/**
 * Clear all cookies for the current document origin.
 * Only cookies visible to this origin can be cleared from JS; cross-origin cookies cannot be removed.
 * Call on sign-out so the next session starts without leftover app/session cookies.
 */
export function clearCookiesForCurrentOrigin(): void {
  if (typeof document === 'undefined' || !document.cookie) return;
  const cookies = document.cookie.split(';');
  const path = '/';
  const expire = 'max-age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  for (let i = 0; i < cookies.length; i++) {
    const part = cookies[i].trim();
    const eq = part.indexOf('=');
    const name = eq > -1 ? part.slice(0, eq).trim() : part;
    if (!name) continue;
    document.cookie = `${name}=; path=${path}; ${expire}`;
  }
}
